// src/services/notificationService.js

export const notificationService = {
  isSupported: () => {
    return 'Notification' in window;
  },

  getPermission: () => {
    if (!notificationService.isSupported()) {
      return 'denied';
    }
    return Notification.permission;
  },

  requestPermission: async () => {
    if (!notificationService.isSupported()) {
      console.warn('Notifications not supported in this browser');
      return false;
    }

    if (Notification.permission === 'granted') {
      console.log('Notification permission already granted');
      return true;
    }

    if (Notification.permission === 'denied') {
      console.warn('Notification permission denied by user');
      return false;
    }

    try {
      const permission = await Notification.requestPermission();
      console.log('Notification permission result:', permission);
      return permission === 'granted';
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  },

  showBrowserNotification: (order) => {
    if (Notification.permission !== 'granted') {
      console.warn('Cannot show notification - permission not granted');
      return null;
    }

    try {
      const notification = new Notification('New Order! 🔔', {
        body: `Table ${order.restaurant_tables?.table_number || order.table_id}\nOrder #${order.order_number}\nAmount: $${order.total_amount}`,
        icon: '/logo192.png',
        badge: '/logo192.png',
        tag: order.id,
        requireInteraction: true,
        vibrate: [300, 100, 300, 100, 500],
        silent: false,
        data: {
          orderId: order.id,
          orderNumber: order.order_number
        }
      });

      notification.onclick = (event) => {
        event.preventDefault();
        window.focus();
        notification.close();
        console.log('Notification clicked for order:', order.order_number);
      };

      notification.onclose = () => {
        console.log('Notification closed for order:', order.order_number);
      };

      notification.onerror = (error) => {
        console.error('Notification error:', error);
      };

      console.log('Browser notification shown for order:', order.order_number);
      return notification;
    } catch (error) {
      console.error('Error showing browser notification:', error);
      return null;
    }
  },

  clearAllNotifications: () => {
    console.log('Clearing notifications');
  }
};